import { FC, ReactNode } from 'react';

import { Stack } from '@mui/material';

import DialogCloseButton from '@/shared/ui/DialogCloseButton';

import { HeaderIcon, HeaderSubtitle, HeaderTitle } from './styles';

interface AwbDialogHeaderProps {
  icon: ReactNode;
  tone?: 'default' | 'success' | 'error';
  title: ReactNode;
  subtitle?: ReactNode;
  onClose: () => void;
  closeTestId?: string;
  subtitleTestId?: string;
  subtitleNoWrap?: boolean;
}

const AwbDialogHeader: FC<AwbDialogHeaderProps> = ({
  icon,
  tone,
  title,
  subtitle,
  onClose,
  closeTestId,
  subtitleTestId,
  subtitleNoWrap = true,
}) => (
  <Stack direction="row" alignItems="center" justifyContent="space-between" gap="1rem">
    <Stack direction="row" alignItems="center" gap="0.5rem" minWidth={0}>
      <HeaderIcon tone={tone}>{icon}</HeaderIcon>
      <Stack minWidth={0}>
        <HeaderTitle>{title}</HeaderTitle>
        {!!subtitle && (
          <HeaderSubtitle noWrap={subtitleNoWrap} data-testid={subtitleTestId}>
            {subtitle}
          </HeaderSubtitle>
        )}
      </Stack>
    </Stack>
    <DialogCloseButton onClick={onClose} data-testid={closeTestId} />
  </Stack>
);

export default AwbDialogHeader;
